import { filter, sumBy, uniqBy } from "lodash";
import moment from "moment";
import { useState } from "react";
import { toast } from "react-toastify";
import {
  GetDailyContainerPlanningIdFromBookingNum,
  GetDailyContainerplanningAggIdFromBookingNum,
  GetDailyContainerplanning5MIDFromBookingNum,
} from "../services/TransporterDataService";
import { getUser } from "../services/authService";

export const standerdDate = (rawDate) => {
  return moment(rawDate).format("YYYY-MM-DD");
};

export const standerdDateForDataCreation = (rawDate) => {
  return moment(rawDate).format("DD-MM-YY");
};

export const dateFormatter = (data, key) => {
  return data.map((item) => {
    return { ...item, [key]: moment(item[key]).format("YYYY-MM-DD") };
  });
};

export const getDaysBetweenDates = (startDate, endDate) => {
  var currDate = moment(startDate).startOf("day");
  var lastDate = moment(endDate).startOf("day");

  var dates = [moment(currDate).format("D-MMM-YY")];
  while (currDate.add(1, "days").diff(lastDate) <= 0) {
    dates.push(moment(currDate.clone().toDate()).format("D-MMM-YY"));
  }

  return dates;
};

export const jdCalenderFilter = (response) => {
  return response.map((item) => {
    return item.DateList;
  });
};

const getStrOrValue = (data, key) => {
  if (data[key]) {
    if (key === "SI" || key === "Remark") {
      return data[key].toString().replace(/[^a-zA-Z0-9]/g, " ");
    } else return data[key].toString();
  } else return "";
};

export const driverUpdateData = (data) => {
  return {
    ...data,
    Driver_License_DOI: standerdDate(data["Driver_License_DOI"]),
    Driver_License_DOE: standerdDate(data["Driver_License_DOE"]),
    Driver_KYC_DOI: standerdDate(data["Driver_KYC_DOI"]),
    Driver_KYC_DOE: standerdDate(data["Driver_KYC_DOE"]),
  };
};

export const truckUpdateDataFormatter = (data) => {
  return {
    ...data,
    RC_Book_DOI: standerdDate(data["RC_Book_DOI"]),
    RC_Book_DOE: standerdDate(data["RC_Book_DOE"]),
    Permit_DOI: standerdDate(data["Permit_DOI"]),
    Permit_DOE: standerdDate(data["Permit_DOE"]),
    PUC_DOI: standerdDate(data["PUC_DOI"]),
    PUC_DOE: standerdDate(data["PUC_DOE"]),
    Insurance_DOI: standerdDate(data["Insurance_DOI"]),
    Insurance_DOE: standerdDate(data["Created_On"]),
    Fitness_DOI: standerdDate(data["Fitness_DOI"]),
    Fitness_DOE: standerdDate(data["Fitness_DOE"]),
    Road_Tax_DOI: standerdDate(data["Road_Tax_DOI"]),
    Road_Tax_DOE: standerdDate(data["Road_Tax_DOE"]),
    Green_Tax_DOI: standerdDate(data["Green_Tax_DOI"]),
    Green_Tax_DOE: standerdDate(data["Green_Tax_DOE"]),
  };
};

//Filters for uploading data

export const dailyReportFilter = (data, planDate, counter) => {
  var tempData = [];
  try {
    for (const item of data) {
      if (item["Market"] && item["Country"] && item["Variant"]) {
        if (item["Container"]) {
          counter = counter + 1;
          tempData.push({
            date: moment(planDate).format("YYYY-MM-DD"),
            market: item["Market"].trim(),
            country: item["Country"].trim(),
            varient_PartNumber: item["Variant"].trim(),
            type: item["Type"],
            category: item["Category"],
            subCategory: item["Sub category"],
            quantity: item["Quantity"],
            container_Count: item["Container"],
            container_Type: "40HC",
            containerId: counter.toString(),
            si: getStrOrValue(item, "SI"),
            remark: getStrOrValue(item, "Remark"),
            created_By: getUser().uid,
          });
        } else {
          tempData.push({
            date: moment(planDate).format("YYYY-MM-DD"),
            market: item["Market"].trim(),
            country: item["Country"].trim(),
            varient_PartNumber: item["Variant"].trim(),
            type: item["Type"],
            category: item["Category"],
            subCategory: item["Sub category"],
            quantity: item["Quantity"],
            // container_Count: 1,
            container_Type: "40HC",
            containerId: counter.toString(),
            si: getStrOrValue(item, "SI"),
            remark: getStrOrValue(item, "Remark"),
            created_By: getUser().uid,
          });
        }
      } else {
        return {
          is_valid: false,
          filteredData: [],
        };
      }
    }
    return {
      is_valid: true,
      filteredData: tempData,
    };
  } catch (error) {
    toast.error("Check file format and try uploading again");
  }
};

export const aggregateDataFiter = (data, planDate, counter) => {
  var tempData = [];
  try {
    for (const item of data) {
      if (item["Country"] && item["Part Number"]) {
        if (item["Container"]) {
          counter = counter + 1;
          tempData.push({
            Date: moment(planDate).format("YYYY-MM-DD"),
            Country: item["Country"].trim(),
            PartNumber: item["Part Number"].trim(),
            Category: item["Category"],
            SubCategory: item["Sub Category"],
            Quantity: item["Quantity"],
            Container_Count: item["Container"],
            Container_Type: item["Container Type"],
            ContainerId: counter.toString(),
            Remark: getStrOrValue(item, "Remark"),
            Created_By: getUser().uid,
          });
        } else {
          tempData.push({
            Date: moment(planDate).format("YYYY-MM-DD"),
            Country: item["Country"].trim(),
            PartNumber: item["Part Number"].trim(),
            Category: item["Category"],
            SubCategory: item["Sub Category"],
            Quantity: item["Quantity"],

            // container_Count: "",

            // container_Count: 1,

            Container_Type: item["Container Type"],
            ContainerId: counter.toString(),
            Remark: getStrOrValue(item, "Remark"),
            Created_By: getUser().uid,
          });
        }
      } else
        return {
          is_valid: false,
          filteredData: [],
        };
    }
    return {
      is_valid: true,
      filteredData: tempData,
    };
  } catch (error) {
    toast.error("Check file format and try uploading again");
  }
};

export const fiveMDataFilter = (data, planDate, counter) => {
  var tempData = [];
  try {
    for (const item of data) {
      if (item["Market"] && item["Country"]) {
        if (item["Container"]) {
          counter = counter + 1;
          tempData.push({
            Date: moment(planDate).format("YYYY-MM-DD"),
            Market: item["Market"].trim(),
            Country: item["Country"].trim(),
            Variant: item["Variant"].trim(),
            Quantity: item["Quantity"],
            Container_Count: item["Container"],
            Container_Type: item["Container Type"],
            ContainerId: counter.toString(),
            SI: getStrOrValue(item, "SI"),
            Remark: getStrOrValue(item, "Remark"),
            Created_By: getUser().uid,
          });
        } else {
          tempData.push({
            Date: moment(planDate).format("YYYY-MM-DD"),
            Market: item["Market"].trim(),
            Country: item["Country"].trim(),
            Variant: item["Variant"].trim(),
            Quantity: item["Quantity"],
            // Container_Count: 1,
            Container_Type: item["Container Type"],
            ContainerId: counter.toString(),
            SI: getStrOrValue(item, "SI"),
            Remark: getStrOrValue(item, "Remark"),
            Created_By: getUser().uid,
          });
        }
      } else
        return {
          is_valid: false,
          filteredData: [],
        };
    }
    return {
      is_valid: true,
      filteredData: tempData,
    };
  } catch (error) {
    toast.error("Check file format and try uploading again");
  }
};

export const DailyETAReportFilter = (data, planDate) => {
  
  var tempData = [];
  try {
    for (const item of data) {
      tempData.push({
        Actual_Pickup_date_from_factory: moment(planDate.fromdate).format("YYYY-MM-DD"),
        SAP_Sales_Order_No: item["SAP Sales Order No."],
        Comar_Order_No: item["Comar Order No."],
        PY_VY_Invoice_No: item["PY/VY Invoice No.(JD India)"],
        Internal_Reference_No: item["Internal Reference No."],
        Container_No: item["Container No."],
        BillType: item["BillType"],
        Serial_Number_of_Product: item["Serial Number of Product"],
        Material_Service_Code: item["Material / Service Code (Part No.)"],
        Billqty: item["Bill qty"],
        Dest_Country: item["Dest Country"],
        Destination_Port: item["Destination Port"],
        CARRIER: item["Carrier"],
        COUNT: item["COUNT"],
        UploadDate: moment(planDate.fromdate).format("YYYY-MM-DD"),
        Engine_No:item["ENGINE No"]
       

      });
    }

    return {
      is_valid: true,
      tempData,
    };
  } catch (error) {
    toast.error("Check file format and try uploading again");
  }
};
export const DailyAggregateETAReportFilter = (data, planDate) => {
  var tempData = [];
  try {
    for (const item of data) {
     
      
      tempData.push({
        Actual_Pickup_date_from_factory:  moment(planDate.fromdate).format("YYYY-MM-DD"),
        SAP_Sales_Order_No: item["SAP Sales Order No."],
        PY_VY_Invoice_No: item["PY/VY Invoice No.(JD India)"],
        Internal_Reference_No: item["Internal Reference No."],
        Container_No: item["Container No."],
        Dest_Country: item["Dest Country"],
        Destination_Port: item["Destination Port"],
        Aggregate_Chassis: item["Aggregate/Chassis"],
        CARRIER: item["Carrier"],
        UploadDate: moment(planDate.fromdate).format("YYYY-MM-DD"),
        Engine_No:item["ENGINE No"]
      });
    }

    return {
      is_valid: true,
      tempData,
    };
  } catch (error) {
    toast.error("Check file format and try uploading again");
  }
};
// End of filter

// Filter to download data

// End filter to download dta

export const getCount = (data) => {
  let conutStore = {
    Booked: 0,
    Pending: 0,
    Approved: 0,
    Cancelled: 0,
    Not_Booked: 0,
  };
  for (const key in data) {
    for (const item of data[key].subRows) {
      if (item["STATUS"] === "Booked") {
        conutStore.Booked = conutStore.Booked + 1;
      }
      if (item["STATUS"] === "Pending") {
        conutStore.Pending = conutStore.Pending + 1;
      }
      if (item["STATUS"] === "Approved") {
        conutStore.Approved = conutStore.Approved + 1;
      }
      if (item["STATUS"] === "Cancelled") {
        conutStore.Cancelled = conutStore.Cancelled + 1;
      }
      if (item["STATUS"] === "Not_Booked") {
        conutStore.Not_Booked = conutStore.Not_Booked + 1;
      }
    }
  }
  return conutStore;
};

export const formatCarrierwiseContainerCount = (data) => {
  let datas = {};
  for (let i = 0; i < data.length; i++) {
    if (data[0].TotalCount) {
      datas["TOTAL"] = data[i].TotalCount;
    }
    if (data[i].Carrier === "OOCL") {
      // containerCount.OOCL = data[i].ContainerCount
      datas[data[i].Carrier] = data[i].ContainerCount;
    }
    if (data[i].Carrier === "ONE") {
      // containerCount.ONE = data[i].ContainerCount
      datas[data[i].Carrier] = data[i].ContainerCount;
    }
    if (data[i].Carrier === "MAERSK") {
      // containerCount.MAERSK = data[i].ContainerCount
      datas[data[i].Carrier] = data[i].ContainerCount;
    }
    if (data[i].Carrier === "HAPAG") {
      // containerCount.HAPAG = data[i].ContainerCount
      datas[data[i].Carrier] = data[i].ContainerCount;
    }
    if (data[i].Carrier === "CMA_CGM") {
      // containerCount.CMA_CGM = data[i].ContainerCount
      datas[data[i].Carrier] = data[i].ContainerCount;
    }
    if (data[i].Carrier === "TS_LINES") {
      // containerCount.TS_LINES = data[i].ContainerCount
      datas[data[i].Carrier] = data[i].ContainerCount;
    }
    if (data[i].Carrier === "MSC") {
      // containerCount.MSC = data[i].ContainerCount
      datas[data[i].Carrier] = data[i].ContainerCount;
    }
    if (data[i].Carrier === "OTHERS") {
      // containerCount.OTHERS = data[i].ContainerCount
      datas[data[i].Carrier] = data[i].ContainerCount;
    }
    // if(data[i].Carrier === null){
    //   containerCount.NULL = data[i].ContainerCount
    // }
  }
  return datas;
};

export const DailyReportFilterForTransporterData = async (
  datas,
  planDate,
  containerValue
) => {
  var bookingList = [];

  for (const item of datas) {
    try {
      if (item["MODULE"] === "TRACTOR") {
        // if (
        //   filter(bookingList, {
        //     Booking_Number: item["BOOKING NO."].toString(),
        //     DataOff: "TRACTOR",
        //   }).length < 1
        // ) {
        const filteredtractorResp =
          await GetDailyContainerPlanningIdFromBookingNum(
            item["BOOKING NO."].toString()
          );
        bookingList = [...bookingList, ...filteredtractorResp.data];
        // }
      }
    } catch (error) {}
    try {
      if (item["MODULE"] === "AGGREGATE") {
        // if (
        //   filter(bookingList, {
        //     Booking_Number: item["BOOKING NO."].toString(),
        //     DataOff: "AGGREGATE",
        //   }).length < 1
        // ) {
        const filteredaggResp =
          await GetDailyContainerplanningAggIdFromBookingNum(
            item["BOOKING NO."].toString()
          );
        bookingList = [...bookingList, ...filteredaggResp.data];
        // }
      }
    } catch (error) {}
    try {
      if (item["MODULE"] === "5M") {
        // if (
        //   filter(bookingList, {
        //     Booking_Number: item["BOOKING NO."].toString(),
        //     DataOff: "FIVEM",
        //   }).length < 1
        // ) {
        const filteredFiveMResp =
          await GetDailyContainerplanning5MIDFromBookingNum(
            item["BOOKING NO."].toString()
          );
        bookingList = [...bookingList, ...filteredFiveMResp.data];
        // }
      }
    } catch (error) {}
  }
  var tempData = [];
  try {
    for (const item of datas) {
      tempData.push({
        date: planDate.fromdate,
        Vehicle_No: item["VEHICLE NO"],
        FLEETX_LR_No: item["FLEETX LR NO"],
        Customer: item["CUSTOMER"],
        Customer_No: item["CUSTOMER NO"],
        Consignee: item["CONSIGNEE"],
        Consignee_name: item["CONSINOR NAME"],
        Clearance: item["CLEARANCE"],
        Empty_yard: item["EMPTY YARD"],
        Movement_type: item["MOVEMENT TYPE"],
        Seal_No: item["SEAL NO"],
        Driver_No: item["DRIVER NO"],
        Booking_Number: item["BOOKING NO."],
        Container_Number: item["CONTAINER NO"],
        Module: item["MODULE"],
      });
    }
    let tractorFinalList = [];
    let aggregateFinalList = [];
    let fiveMFinalList = [];
    for (const item of bookingList) {
      for (const order of tempData) {
        if (
          item.Booking_Number.toString() === order.Booking_Number.toString()
        ) {
          if (
            item.DailyContainerPlanningId &&
            item.DataOff === "TRACTOR" &&
            order.Module === "TRACTOR"
          ) {
            // if (
            //   filter(tractorFinalList, {
            //     DailyContainerPlanningId: item.DailyContainerPlanningId,
            //   }).length < 1
            // ) {
            if (
              filter(tractorFinalList, {
                Container_Number: order.Container_Number.toString(),
              }).length < 1
            ) {
              tractorFinalList.push({
                DailyContainerPlanningId: item.DailyContainerPlanningId,
                Vehicle_No: order.Vehicle_No ? order.Vehicle_No.toString() : "",
                FLEETX_LR_No: order.FLEETX_LR_No
                  ? order.FLEETX_LR_No.toString()
                  : "",
                Customer: order.Customer ? order.Customer.toString() : "",
                // Customer_No: order.Customer_No
                //   ? order.Customer_No.toString()
                //   : "",
                Consignee: order.Consignee ? order.Consignee.toString() : "",
                Consignee_name: order.Consignee_name
                  ? order.Consignee_name.toString()
                  : "",
                Clearance: order.Clearance ? order.Clearance.toString() : "",
                Empty_yard: order.Empty_yard ? order.Empty_yard.toString() : "",
                Movement_type: order.Movement_type
                  ? order.Movement_type.toString()
                  : "",
                Seal_No: order.Seal_No ? order.Seal_No.toString() : "",
                Driver_No: order.Driver_No ? order.Driver_No.toString() : "",
                Booking_Number: order.Booking_Number
                  ? order.Booking_Number.toString()
                  : "",
                Container_Number: order.Container_Number
                  ? order.Container_Number.toString()
                  : "",
                date: planDate.fromdate,
                Module: order.Module ? order.Module : "",
                Pick_up_Location: containerValue.pick_up_location,
              });
            }
            // }
          }
          if (
            item.DailyContainerPlanningAggregateId &&
            item.DataOff === "AGGREGATE" &&
            order.Module === "AGGREGATE"
          ) {
            // if (
            //   filter(aggregateFinalList, {
            //     DailyContainerPlanningAggregateId:
            //       item.DailyContainerPlanningAggregateId,
            //   }).length < 1
            // ) {
            if (
              filter(aggregateFinalList, {
                Container_Number: order.Container_Number.toString(),
              }).length < 1
            ) {
              aggregateFinalList.push({
                Vehicle_No: order.Vehicle_No ? order.Vehicle_No.toString() : "",
                FLEETX_LR_No: order.FLEETX_LR_No
                  ? order.FLEETX_LR_No.toString()
                  : "",
                Customer: order.Customer ? order.Customer.toString() : "",
                // Customer_No: order.Customer_No
                //   ? order.Customer_No.toString()
                //   : "",
                Consignee: order.Consignee ? order.Consignee.toString() : "",
                Consignee_name: order.Consignee_name
                  ? order.Consignee_name.toString()
                  : "",
                Clearance: order.Clearance ? order.Clearance.toString() : "",
                Empty_yard: order.Empty_yard ? order.Empty_yard.toString() : "",
                Movement_type: order.Movement_type
                  ? order.Movement_type.toString()
                  : "",
                Seal_No: order.Seal_No ? order.Seal_No.toString() : "",
                Driver_No: order.Driver_No ? order.Driver_No.toString() : "",
                Booking_Number: order.Booking_Number
                  ? order.Booking_Number.toString()
                  : "",
                Container_Number: order.Container_Number
                  ? order.Container_Number.toString()
                  : "",
                date: planDate.fromdate,
                DailyContainerPlanningAggregateId:
                  item.DailyContainerPlanningAggregateId,
                Module: order.Module ? order.Module : "",
                Pick_up_Location: containerValue.pick_up_location,
              });
            }
            // }
          }
          if (
            item.DailyContainerPlanning5MId &&
            item.DataOff === "5M" &&
            order.Module === "5M"
          ) {
            // if (
            //   filter(fiveMFinalList, {
            //     DailyContainerPlanning5MId: item.DailyContainerPlanning5MId,
            //   }).length < 1
            // ) {
            if (
              filter(fiveMFinalList, {
                Container_Number: order.Container_Number.toString(),
              }).length < 1
            ) {
              fiveMFinalList.push({
                Vehicle_No: order.Vehicle_No ? order.Vehicle_No.toString() : "",
                FLEETX_LR_No: order.FLEETX_LR_No
                  ? order.FLEETX_LR_No.toString()
                  : "",
                Customer: order.Customer ? order.Customer.toString() : "",
                // Customer_No: order.Customer_No
                //   ? order.Customer_No.toString()
                //   : "",
                Consignee: order.Consignee ? order.Consignee.toString() : "",
                Consignee_name: order.Consignee_name
                  ? order.Consignee_name.toString()
                  : "",
                Clearance: order.Clearance ? order.Clearance.toString() : "",
                Empty_yard: order.Empty_yard ? order.Empty_yard.toString() : "",
                Movement_type: order.Movement_type
                  ? order.Movement_type.toString()
                  : "",
                Seal_No: order.Seal_No ? order.Seal_No.toString() : "",
                Driver_No: order.Driver_No ? order.Driver_No.toString() : "",
                Booking_Number: order.Booking_Number
                  ? order.Booking_Number.toString()
                  : "",
                Container_Number: order.Container_Number
                  ? order.Container_Number.toString()
                  : "",
                date: planDate.fromdate,
                DailyContainerPlanning5MId: item.DailyContainerPlanning5MId,
                Module: order.Module ? order.Module : "",
                Pick_up_Location: containerValue.pick_up_location,
              });
            }
            // }
          }
        }
      }
    }
    return {
      is_valid: true,
      filteredTractorData: tractorFinalList,
      filteredAggregateData: aggregateFinalList,
      filtered5MData: fiveMFinalList,
    };
  } catch (error) {
    toast.error("Check file format and try uploading again");
    return {
      is_valid: false,
      filteredTractorData: [],
      filteredAggregateData: [],
      filtered5MData: [],
    };
  }
};

//Test comment

export const tractorDataCreatorForStore = (data) => {
  // var finalData = {};
  var sameIdDataMap = {};
  for (const item of data) {
    if (sameIdDataMap.hasOwnProperty(item.Market)) {
      sameIdDataMap[item.Market].push({
        ...item,
        Date: standerdDate(item["Date"]),
        ETD: standerdDate(item["ETD"]),
        ETA: standerdDate(item["ETA"]),
        Factory_In_Date: standerdDate(item["Factory_In_Date"]),
        Factory_Out_Date: standerdDate(item["Factory_Out_Date"]),
        JD_Stuffing_Date: standerdDate(item["JD_Stuffing_Date"]),
        Origin_Transit_Time: item.Origin_Transit_Time
          ? `${item["Origin_Transit_Time"]} days`
          : "0 days",
        Ground_Rent_Days: item.Ground_Rent_Days
          ? `${item["Ground_Rent_Days"]} days`
          : "0 days",
        Approx_container_detention: item.Approx_container_detention
          ? `${item["Approx_container_detention"]} days`
          : "0 days",
      });
    } else {
      sameIdDataMap[item.Market] = {
        ...item,
        Date: standerdDate(item["Date"]),
        ETD: standerdDate(item["ETD"]),
        ETA: standerdDate(item["ETA"]),
        Factory_In_Date: standerdDate(item["Factory_In_Date"]),
        Factory_Out_Date: standerdDate(item["Factory_Out_Date"]),
        JD_Stuffing_Date: standerdDate(item["JD_Stuffing_Date"]),
        Origin_Transit_Time: item.Origin_Transit_Time
          ? `${item["Origin_Transit_Time"]} days`
          : "0 days",
        Ground_Rent_Days: item.Ground_Rent_Days
          ? `${item["Ground_Rent_Days"]} days`
          : "0 days",
        Approx_container_detention: item.Approx_container_detention
          ? `${item["Approx_container_detention"]} days`
          : "0 days",
      };
      // ];
    }
  }
  return sameIdDataMap;
};

export const aggregateDataCreatorForStore = (data) => {
  // var finalData = {};
  var sameIdDataMap = {};
  for (const item of data) {
    if (sameIdDataMap.hasOwnProperty(item.Country)) {
      sameIdDataMap[item.Country].push({
        ...item,
        Date: standerdDateForDataCreation(item["Date"]),
        ETD: standerdDate(item["ETD"]),
        ETA: standerdDate(item["ETA"]),
        Factory_In_Date: standerdDate(item["Factory_In_Date"]),
        Factory_Out_Date: standerdDate(item["Factory_Out_Date"]),
        JD_Stuffing_Date: standerdDate(item["JD_Stuffing_Date"]),
        Origin_Transit_Time: item.Origin_Transit_Time
          ? `${item["Origin_Transit_Time"]} days`
          : "0 days",
        Ground_Rent_Days: item.Ground_Rent_Days
          ? `${item["Ground_Rent_Days"]} days`
          : "0 days",
        Approx_container_detention: item.Approx_container_detention
          ? `${item["Approx_container_detention"]} days`
          : "0 days",
      });
    } else {
      sameIdDataMap[item.Country] = {
        ...item,
        Date: standerdDateForDataCreation(item["Date"]),
        ETD: standerdDate(item["ETD"]),
        ETA: standerdDate(item["ETA"]),
        Factory_In_Date: standerdDate(item["Factory_In_Date"]),
        Factory_Out_Date: standerdDate(item["Factory_Out_Date"]),
        JD_Stuffing_Date: standerdDate(item["JD_Stuffing_Date"]),
        Origin_Transit_Time: item.Origin_Transit_Time
          ? `${item["Origin_Transit_Time"]} days`
          : "0 days",
        Ground_Rent_Days: item.Ground_Rent_Days
          ? `${item["Ground_Rent_Days"]} days`
          : "0 days",
        Approx_container_detention: item.Approx_container_detention
          ? `${item["Approx_container_detention"]} days`
          : "0 days",
      };
      // ];
    }
  }
  return sameIdDataMap;
};

export const fiveMDataCreatorForStore = (data) => {
  // var finalData = {};
  var sameIdDataMap = {};
  for (const item of data) {
    if (sameIdDataMap.hasOwnProperty(item.Market)) {
      sameIdDataMap[item.Market].push({
        ...item,
        Date: standerdDateForDataCreation(item["Date"]),
        ETD: standerdDate(item["ETD"]),
        ETA: standerdDate(item["ETA"]),
        Factory_In_Date: standerdDate(item["Factory_In_Date"]),
        Factory_Out_Date: standerdDate(item["Factory_Out_Date"]),
        JD_Stuffing_Date: standerdDate(item["JD_Stuffing_Date"]),
        Origin_Transit_Time: item.Origin_Transit_Time
          ? `${item["Origin_Transit_Time"]} days`
          : "0 days",
        Ground_Rent_Days: item.Ground_Rent_Days
          ? `${item["Ground_Rent_Days"]} days`
          : "0 days",
        Approx_container_detention: item.Approx_container_detention
          ? `${item["Approx_container_detention"]} days`
          : "0 days",
      });
    } else {
      sameIdDataMap[item.Market] = {
        ...item,
        Date: standerdDateForDataCreation(item["Date"]),
        ETD: standerdDate(item["ETD"]),
        ETA: standerdDate(item["ETA"]),
        Factory_In_Date: standerdDate(item["Factory_In_Date"]),
        Factory_Out_Date: standerdDate(item["Factory_Out_Date"]),
        JD_Stuffing_Date: standerdDate(item["JD_Stuffing_Date"]),
        Origin_Transit_Time: item.Origin_Transit_Time
          ? `${item["Origin_Transit_Time"]} days`
          : "0 days",
        Ground_Rent_Days: item.Ground_Rent_Days
          ? `${item["Ground_Rent_Days"]} days`
          : "0 days",
        Approx_container_detention: item.Approx_container_detention
          ? `${item["Approx_container_detention"]} days`
          : "0 days",
      };
      // ];
    }
  }
  return sameIdDataMap;
};

export const allModuleDataCreatorForStore = (data) => {
  var finalData = {};
  var sameIdDataMap = {};
  for (const item of data) {
    if (sameIdDataMap.hasOwnProperty(item.Transporter)) {
      sameIdDataMap[item.Transporter].push({
        ...item,
        Date: standerdDateForDataCreation(item["Date"]),
        ETD: standerdDate(item["ETD"]),
        ETA: standerdDate(item["ETA"]),
        JD_Stuffing_Date: item["JD_Stuffing_Date"]
          ? standerdDateForDataCreation(item["JD_Stuffing_Date"])
          : "",
        Factory_In_Date: standerdDate(item["Factory_In_Date"]),
        Factory_Out_Date: standerdDate(item["Factory_Out_Date"]),
        Origin_Transit_Time: item.Origin_Transit_Time
          ? `${item["Origin_Transit_Time"]} days`
          : "0 days",
        Ground_Rent_Days: item.Ground_Rent_Days
          ? `${item["Ground_Rent_Days"]} days`
          : "0 days",
        Approx_container_detention: item.Approx_container_detention
          ? `${item["Approx_container_detention"]} days`
          : "0 days",
        ContainerId: `${item.ContainerId}_${item.DataOf}`,
      });
    } else {
      sameIdDataMap[item.Transporter] = [
        {
          ...item,
          Date: standerdDateForDataCreation(item["Date"]),
          ETD: standerdDate(item["ETD"]),
          ETA: standerdDate(item["ETA"]),
          Factory_In_Date: standerdDate(item["Factory_In_Date"]),
          Factory_Out_Date: standerdDate(item["Factory_Out_Date"]),
          JD_Stuffing_Date: item["JD_Stuffing_Date"]
            ? standerdDateForDataCreation(item["JD_Stuffing_Date"])
            : "",
          Origin_Transit_Time: item.Origin_Transit_Time
            ? `${item["Origin_Transit_Time"]} days`
            : "0 days",
          Ground_Rent_Days: item.Ground_Rent_Days
            ? `${item["Ground_Rent_Days"]} days`
            : "0 days",
          Approx_container_detention: item.Approx_container_detention
            ? `${item["Approx_container_detention"]} days`
            : "0 days",
          ContainerId: `${item.ContainerId}_${item.DataOf}`,
        },
      ];
    }
  }
  Object.keys(sameIdDataMap).map((item) => {
    sameIdDataMap[item].map((data) => {
      const uniqContainerCountData = uniqBy(sameIdDataMap[item], "ContainerId");
      function functionData(datas) {
        var resultData = [];
        for (const item of datas) {
          if (
            filter(uniqContainerCountData, {
              DailyContainerPlanningID: item.DailyContainerPlanningID,
            }).length > 0
          ) {
            resultData.push({
              ...item,
              Container_Count: item.Container_Count,
            });
          } else {
            resultData.push({
              ...item,
              Container_Count: "",
              STATUS: "",
            });
          }
        }
        return resultData;
      }
      var tableRow = {
        // AssignContainerId: data.AssignContainerId,
        DailyContainerPlanningId: data.DailyContainerPlanningId,
        Transporter: item !== "null" ? item : "-",
        Varient_PartNumber: "",
        Quantity: sumBy(sameIdDataMap[item], function (sum) {
          return sum.Quantity;
        }),
        Country: "",
        Port_Of_Destination: "",
        Container_Count: sumBy(uniqContainerCountData, function (sum) {
          return sum.Container_Count;
        }),
        Container_Type: "",
        Inspection: "",
        SI: "",
        Remark: "",
        BookingDocument: data.BookingDocument,
        subRows: functionData(sameIdDataMap[item]),
      };
      finalData[item] = tableRow;
    });
  });
  return finalData;
};

export const PortwiseContainerCountReportFilter = (data) => {
  const [POD, setPOD] = useState("");
  const tableRow = {
    DataOf: "",
    Port_Of_Destination: "",
    Container_Count: "",
  };
  const uniqPOD = uniqBy(data, "Port_Of_Destination", "DataOf");
  for (let i = 0; i < uniqPOD.length; i++) {
    tableRow.Port_Of_Destination = uniqPOD[i].Port_Of_Destination;
    setPOD(...POD, uniqPOD[i].Port_Of_Destination);
  }
};

export const FormatContainerMasterData = (data) => {
  var finalData = [];
  var finalIds = [
    {
      DataOf: "",
      ContainerNo: "",
    },
  ];
  for (const item of data) {
    finalIds.push({
      ContainerNo: item.ContainerNo,
      DataOf: item.DataOf,
    });
    finalData.push({
      ...item,
      Date: item.Date ? moment(item.Date).format("DD-MM-YYYY") : "",
      Gate_In_Date: item.Gate_In_Date
        ? moment(item.Gate_In_Date).format("DD-MM-YYYY")
        : "",
      Gate_Out_Date:item.Gate_Out_Date
      ? moment(item.Gate_Out_Date).format("DD-MM-YYYY")
      : "",
      Invoice: item.Invoice ? item.Invoice : "",
      T_qty: item.T_qty ? item.T_qty : "",
      A_qty: item.A_qty ? item.A_qty : "",
      A_Part: item.A_Part ? item.A_Part : "",
      RFID_Seal_No: item.RFID_Seal_No ? item.RFID_Seal_No : "",
      ContainerNo: item.ContainerNo ? item.ContainerNo : "",
      SEAL_NO: item.SEAL_NO ? item.SEAL_NO : "",
      LR_NO: item.LR_NO ? item.LR_NO : "",
      Vehicle_No: item.Vehicle_No ? item.Vehicle_No : "",
      Carrier: item.Carrier ? item.Carrier : "",
      Clearence: item.Clearance ? item.Clearance : "",
      Dest_Country: item.Dest_Country ? item.Dest_Country : "",
      Dest_Port: item.Dest_Port ? item.Dest_Port : "",
      final_destination: item.final_destination ? item.final_destination : "",
      Product: item.Product ? item.Product : "",
      Booking_Number: item.Booking_Number ? item.Booking_Number : "",
      Transporter: item.Transporter ? item.Transporter : "",
      pick_up_location: item.pick_up_location ? item.pick_up_location : "",
      SAP_code: item.SAP_code ? item.SAP_code : "",
      Container_Size: item.Container_Size ? item.Container_Size : "",
      Driver_No: item.Driver_No ? item.Driver_No : "",
      Remarks: item.Remarks ? item.Remarks : "",
    });
    // }
  } 
  return finalData;
};

export const FormatContainerMasterDataForEmail = (data) => {
  var finalData = [];
  var finalIds = [
    {
      DataOf: "",
      ContainerNo: "",
    },
  ];
  for (const item of data) {
    // if (
    //   filter(finalIds, { DataOf: item.DataOf, ContainerNo: item.ContainerNo })
    //     .length < 1
    // ) {
    finalIds.push({
      ContainerNo: item.ContainerNo,
      DataOf: item.DataOf,
    });
    finalData.push({
      ...item,
      Date: item.Date ? moment(item.Date).format("DD-MM-YYYY") : "",
      Gate_In_Date: item.Gate_In_Date
        ? moment(item.Gate_In_Date).format("DD-MM-YYYY hh:mm A")
        : "",
      Gate_Out_Date: item.Gate_Out_Date
        ? moment(item.Gate_Out_Date).format("DD-MM-YYYY hh:mm A")
        : "",
      Invoice: item.Invoice ? item.Invoice : "",
      T_qty: item.T_qty ? item.T_qty : "",
      A_qty: item.A_qty ? item.A_qty : "",
      A_Part: item.A_Part ? item.A_Part : "",
      RFID_Seal_No: item.RFID_Seal_No ? item.RFID_Seal_No : "",
      ContainerNo: item.ContainerNo ? item.ContainerNo : "",
      SEAL_NO: item.SEAL_NO ? item.SEAL_NO : "",
      LR_NO: item.LR_NO ? item.LR_NO : "",
      Vehicle_No: item.Vehicle_No ? item.Vehicle_No : "",
      Carrier: item.Carrier ? item.Carrier : "",
      Clearence: item.Clearance ? item.Clearance : "",
      Dest_Country: item.Dest_Country ? item.Dest_Country : "",
      Dest_Port: item.Dest_Port ? item.Dest_Port : "",
      final_destination: item.final_destination ? item.final_destination : "",
      Product: item.Product ? item.Product : "",
      Booking_Number: item.Booking_Number ? item.Booking_Number : "",
      Transporter: item.Transporter ? item.Transporter : "",
      pick_up_location: item.pick_up_location ? item.pick_up_location : "",
      SAP_code: item.SAP_code ? item.SAP_code : "",
      Container_Size: item.Container_Size ? item.Container_Size : "",
      Driver_No: item.Driver_No ? item.Driver_No : "",
      Remarks: item.Remarks ? item.Remarks : "",
    });
    // }
  }
  return finalData;
};

export const FormatArrivalReportData = (data) => {
  var finalData = [];
  var finalIds = [
    {
      DataOf: "",
      ContainerNo: "",
    },
  ];
  for (const item of data) {
    // if (
    //   filter(finalIds, { DataOf: item.DataOf, ContainerNo: item.ContainerNo })
    //     .length < 1
    // ) {
    finalIds.push({
      ContainerNo: item.ContainerNo,
      DataOf: item.DataOf,
    });
    finalData.push({
      ...item,
      Date: item.Date ? moment(item.Date).format("DD-MM-YYYY") : "",
      Factory_In_Date: item.Factory_In_Date
        ? moment(item.Factory_In_Date).format("DD-MM-YYYY")
        : "",
      Gate_In_Date: item.Gate_In_Date
        ? // ? `${moment(item.Gate_In_Date).format("YYYY-MM-DDThh:mm")}`
          `${new Date(item.Gate_In_Date).toISOString()}`
        : "",
      Factory_Out_Date: item.Factory_Out_Date
        ? moment(item.Factory_Out_Date).format("DD-MM-YYYY")
        : "",
      Invoice: item.Invoice ? item.Invoice : "",
      T_qty: item.T_qty ? item.T_qty : null,
      A_qty: item.A_qty ? item.A_qty : null,
      A_Part: item.A_Part ? item.A_Part : "",
      RFID_Seal_No: item.RFID_Seal_No ? item.RFID_Seal_No : "",
      ContainerNo: item.ContainerNo ? item.ContainerNo : "",
      SEAL_NO: item.SEAL_NO ? item.SEAL_NO : "",
      LR_NO: item.LR_NO ? item.LR_NO : "",
      Vehicle_No: item.Vehicle_No ? item.Vehicle_No : "",
      Carrier: item.Carrier ? item.Carrier : "",
      Clearence: item.Clearance ? item.Clearance : "",
      Dest_Country: item.Country ? item.Country : "",
      Dest_Port: item.Port_Of_Destination ? item.Port_Of_Destination : "",
      final_destination: item.final_destination ? item.final_destination : "",
      Product: item.Product ? item.Product : "",
      Booking_Number: item.Booking_Number ? item.Booking_Number : "",
      Transporter: item.Transporter ? item.Transporter : "",
      pick_up_location: item.pick_up_location ? item.pick_up_location : "",
      SAP_code: item.SAP_code ? item.SAP_code : "",
      Container_Size: item.Container_Size ? item.Container_Size : "",
      Driver_No: item.Driver_No ? item.Driver_No : "",
      Remark: item.Remark ? item.Remark : "",
    });
    // }
  }
  return finalData;
};

export const FormatDepartureReportData = (data) => {
  var finalData = [];
  var finalIds = [
    {
      DataOf: "",
      ContainerNo: "",
    },
  ];
  for (const item of data) {
    // if (
    //   filter(finalIds, { DataOf: item.DataOf, ContainerNo: item.ContainerNo })
    //     .length < 1
    // ) {
    finalIds.push({
      ContainerNo: item.ContainerNo,
      DataOf: item.DataOf,
    });
    finalData.push({
      ...item,
      Date: item.Date ? moment(item.Date).format("DD-MM-YYYY") : "",
      Factory_In_Date: item.Factory_In_Date
        ? moment(item.Factory_In_Date).format("DD-MM-YYYY")
        : "",
      Gate_In_Date: item.Gate_In_Date
        ? moment(item.Gate_In_Date).format("DD-MM-YYYY hh:mm A")
        : "",
      Gate_Out_Date: item.Gate_Out_Date
        ? // ? moment(item.Gate_Out_Date).format("YYYY-MM-DDThh:mm")
          `${new Date(item.Gate_Out_Date).toISOString()}`
        : "",
      Factory_Out_Date: item.Factory_Out_Date
        ? moment(item.Factory_Out_Date).format("DD-MM-YYYY")
        : "",
      Invoice: item.Invoice ? item.Invoice : "",
      T_qty: item.T_qty ? item.T_qty : null,
      A_qty: item.A_qty ? item.A_qty : null,
      A_Part: item.A_Part ? item.A_Part : "",
      RFID_Seal_No: item.RFID_Seal_No ? item.RFID_Seal_No : "",
      ContainerNo: item.ContainerNo ? item.ContainerNo : "",
      SEAL_NO: item.SEAL_NO ? item.SEAL_NO : "",
      LR_NO: item.LR_NO ? item.LR_NO : "",
      Vehicle_No: item.Vehicle_No ? item.Vehicle_No : "",
      Carrier: item.Carrier ? item.Carrier : "",
      Clearence: item.Clearance ? item.Clearance : "",
      Dest_Country: item.Country ? item.Country : "",
      Dest_Port: item.Port_Of_Destination ? item.Port_Of_Destination : "",
      final_destination: item.final_destination ? item.final_destination : "",
      Product: item.Product ? item.Product : "",
      Booking_Number: item.Booking_Number ? item.Booking_Number : "",
      Transporter: item.Transporter ? item.Transporter : "",
      pick_up_location: item.pick_up_location ? item.pick_up_location : "",
      SAP_code: item.SAP_code ? item.SAP_code : "",
      Container_Size: item.Container_Size ? item.Container_Size : "",
      Driver_No: item.Driver_No ? item.Driver_No : "",
      Remark: item.Remark ? item.Remark : "",
      isOnHold: item.isOnHold ? item.isOnHold : "",
      Back_To_Town: item.Back_To_Town ? item.Back_To_Town : "",
    });
    // }
  }
  return finalData;
};

export const FormatDepartureReportDataForMail = (data) => {
  var finalData = [];
  var finalIds = [
    {
      DataOf: "",
      ContainerNo: "",
    },
  ];
  for (const item of data) {
    // if (
    //   filter(finalIds, { DataOf: item.DataOf, ContainerNo: item.ContainerNo })
    //     .length < 1
    // ) {
    finalIds.push({
      ContainerNo: item.ContainerNo,
      DataOf: item.DataOf,
    });
    finalData.push({
      ...item,
      Date: item.Date ? moment(item.Date).format("DD-MM-YYYY") : "",
      Factory_In_Date: item.Factory_In_Date
        ? moment(item.Factory_In_Date).format("DD-MM-YYYY")
        : "",
      Gate_In_Date: item.Gate_In_Date
        ? moment(item.Gate_In_Date).format("DD-MM-YYYY hh:mm A")
        : "",
      Gate_Out_Date: item.Gate_Out_Date
        ? // ? moment(item.Gate_Out_Date).format("YYYY-MM-DDThh:mm")
          moment(item.Gate_Out_Date).format("DD-MM-YYYY hh:mm A")
        : "",
      Factory_Out_Date: item.Factory_Out_Date
        ? moment(item.Factory_Out_Date).format("DD-MM-YYYY")
        : "",
      Invoice: item.Invoice ? item.Invoice : "",
      T_qty: item.T_qty ? item.T_qty : null,
      A_qty: item.A_qty ? item.A_qty : null,
      A_Part: item.A_Part ? item.A_Part : "",
      RFID_Seal_No: item.RFID_Seal_No ? item.RFID_Seal_No : "",
      ContainerNo: item.ContainerNo ? item.ContainerNo : "",
      SEAL_NO: item.SEAL_NO ? item.SEAL_NO : "",
      LR_NO: item.LR_NO ? item.LR_NO : "",
      Vehicle_No: item.Vehicle_No ? item.Vehicle_No : "",
      Carrier: item.Carrier ? item.Carrier : "",
      Clearence: item.Clearance ? item.Clearance : "",
      Dest_Country: item.Country ? item.Country : "",
      Dest_Port: item.Port_Of_Destination ? item.Port_Of_Destination : "",
      final_destination: item.final_destination ? item.final_destination : "",
      Product: item.Product ? item.Product : "",
      Booking_Number: item.Booking_Number ? item.Booking_Number : "",
      Transporter: item.Transporter ? item.Transporter : "",
      pick_up_location: item.pick_up_location ? item.pick_up_location : "",
      SAP_code: item.SAP_code ? item.SAP_code : "",
      Container_Size: item.Container_Size ? item.Container_Size : "",
      Driver_No: item.Driver_No ? item.Driver_No : "",
      Remark: item.Remark ? item.Remark : "",
      isOnHold: item.isOnHold ? item.isOnHold : "",
      Back_To_Town: item.Back_To_Town ? item.Back_To_Town : "",
    });
    // }
  }
  return finalData;
};

export const VGMGetDataFilter = (data) => {
  var finalData = [];
  for (let i = 0; i < data.length; i++) {
    finalData.push({
      VGMId: data[i]["VGMId"],
      TransporterDataId: data[i]["TransporterDataId"],
      shippername: "John Deere India Private Limited",
      Shipper_Lic_No: "3100006364",
      Shipper_Authorised_Name: data[i]["Shipper_Authorised_Name"],
      Mobile_Number: data[i]["Mobile_Number"],
      DataOf: data[i]["DataOf"],
      Container_Number: data[i]["Container_Number"],
      Container_Type: data[i]["Container_Type"],
      Container_Weight: data[i]["Container_Weight"],
      Weibridge_Address:
        "Sunglow Weight Bridge, Gate No. 1227/1, Sanswadi,Pune Nagar Road,L & T Phat, Tal.Shirur, Dist. Pune.",
      Weibridge_Reg_No: "Reg No-146617",
      Container_Mass: data[i]["Container_Mass"],
      Weighing_Date: data[i]["Weighing_Date"]
        ? `${new Date(data[i].Weighing_Date).toISOString()}`
        : "",
      // Weighing_Date: data[i]["Weighing_Date"] ? moment(data[i]["Weighing_Date"]).format("DD-MM-YYYY HH:mm:ss"):"",
      Weighing_Slip_No: data[i]["Weighing_Slip_No"],
      VGM_Type: data[i]["VGM_Type"],
      Remarks: data[i]["Remarks"],
      VGMDoc: data[i]["VGMDoc"],
    });
  }
  return finalData;
};

export const VGMGetDataFilterForMail = (data) => {
  var finalData = [];
  for (let i = 0; i < data.length; i++) {
    finalData.push({
      VGMId: data[i]["VGMId"],
      TransporterDataId: data[i]["TransporterDataId"],
      shippername: "John Deere India Private Limited",
      Shipper_Lic_No: "3100006364",
      Shipper_Authorised_Name: "Mr. Rahul Natu",
      Mobile_Number: "9604891115",
      DataOf: data[i]["DataOf"],
      Container_Number: data[i]["Container_Number"],
      Container_Type: data[i]["Container_Type"],
      Container_Weight: data[i]["Container_Weight"],
      Weibridge_Address:
        "Sunglow Weight Bridge, Gate No. 1227/1, Sanswadi,Pune Nagar Road,L & T Phat, Tal.Shirur, Dist. Pune.",
      Weibridge_Reg_No: "Reg No-146617",
      Container_Mass: data[i]["Container_Mass"],
      // Weighing_Date: data[i]["Weighing_Date"] ? `${new Date(data[i].Weighing_Date).toISOString()}`:"",
      Weighing_Date: data[i]["Weighing_Date"]
        ? moment(data[i]["Weighing_Date"]).format("DD-MM-YYYY HH:mm A")
        : "",
      Weighing_Slip_No: data[i]["Weighing_Slip_No"],
      VGM_Type: data[i]["VGM_Type"],
      Remarks: data[i]["Remarks"],
      VGMDoc: data[i]["VGMDoc"],
      isEmailSentTractor: data[i]["isEmailSentTractor"],
      isEmailSentAggregate: data[i]["isEmailSentAggregate"],
      isEmailSent5M: data[i]["isEmailSent5M"],
    });
  }
  return finalData;
};
